import { useNavigate } from "react-router-dom";

function VideoInstitucional() {
  const navigate = useNavigate();

  const videoUrl = process.env.REACT_APP_VIDEO_URL;

  const handleVoltar = () => {
    navigate(-1);
  };

  return (
    <div className="w-full min-h-screen bg-black flex items-center justify-center px-8">
      <div className="w-full max-w-6xl flex flex-col items-center gap-8">
        <video
          className="w-full max-h-[70vh] bg-black"
          src={videoUrl}
          autoPlay
          loop
          playsInline
          controls={false}
        >
          Seu navegador não suporta reprodução de vídeo.
        </video>

        <button
          onClick={handleVoltar}
          className="self-start min-w-[200px] py-4 border-2 border-white text-white px-12 rounded-2xl text-3xl font-medium transition"
        >
          Voltar
        </button>
      </div>
    </div>
  );
}

export default VideoInstitucional;
